// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.top-navbar {
  background-color: rgba(15, 23, 42, 0.95);
  backdrop-filter: blur(8px);
  border-bottom: 1px solid #1e293b;
  position: sticky;
  top: 0;
  z-index: 50;
}

.nav-inner {
  max-width: 1120px;
  margin: 0 auto;
  padding: 0.9rem 1.5rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 1rem;
}

.brand {
  display: flex;
  align-items: center;
  gap: 0.6rem;
}

.brand-icon {
  font-size: 1.4rem;
}

.brand-title {
  font-size: 1.1rem;
  font-weight: 800;
  letter-spacing: 0.05em;
  color: #38bdf8;
}

.nav-links {
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
}

.nav-button {
  background: transparent;
  border: 1px solid transparent;
  color: #94a3b8;
  padding: 0.45rem 0.9rem;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 500;
  font-size: 0.9rem;
  transition: all 0.2s ease;
}

.nav-button:hover {
  color: #f1f5f9;
  background-color: #1e293b;
}

.nav-button.active {
  color: #38bdf8;
  background-color: rgba(56, 189, 248, 0.1);
  border-color: rgba(56, 189, 248, 0.3);
}`, "",{"version":3,"sources":["webpack://./src/components/Navbar.css"],"names":[],"mappings":"AAAA;EACE,wCAAwC;EACxC,0BAA0B;EAC1B,gCAAgC;EAChC,gBAAgB;EAChB,MAAM;EACN,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,sBAAsB;EACtB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,6BAA6B;EAC7B,cAAc;EACd,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,yCAAyC;EACzC,qCAAqC;AACvC","sourcesContent":[".top-navbar {\n  background-color: rgba(15, 23, 42, 0.95);\n  backdrop-filter: blur(8px);\n  border-bottom: 1px solid #1e293b;\n  position: sticky;\n  top: 0;\n  z-index: 50;\n}\n\n.nav-inner {\n  max-width: 1120px;\n  margin: 0 auto;\n  padding: 0.9rem 1.5rem;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 1rem;\n}\n\n.brand {\n  display: flex;\n  align-items: center;\n  gap: 0.6rem;\n}\n\n.brand-icon {\n  font-size: 1.4rem;\n}\n\n.brand-title {\n  font-size: 1.1rem;\n  font-weight: 800;\n  letter-spacing: 0.05em;\n  color: #38bdf8;\n}\n\n.nav-links {\n  display: flex;\n  gap: 0.5rem;\n  flex-wrap: wrap;\n}\n\n.nav-button {\n  background: transparent;\n  border: 1px solid transparent;\n  color: #94a3b8;\n  padding: 0.45rem 0.9rem;\n  border-radius: 6px;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 0.9rem;\n  transition: all 0.2s ease;\n}\n\n.nav-button:hover {\n  color: #f1f5f9;\n  background-color: #1e293b;\n}\n\n.nav-button.active {\n  color: #38bdf8;\n  background-color: rgba(56, 189, 248, 0.1);\n  border-color: rgba(56, 189, 248, 0.3);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
